<template>
  <b-modal modal-class=""
           body-class="price-list"
           centered
           hide-header
           hide-header-close
           :hide-footer="isPreview"
           no-close-on-backdrop
           :no-close-on-esc="isPreview"
           :id="modalIdentifier"
           size="md"
  >
    <div v-if="priceListImg">
      <img :src="priceListImg" :alt="eventName" class="w-100">
    </div>
    <div class="position-relative" v-else>
      <div class="price-list__demo" v-if="isDemo">DEMO</div>
      <div class="d-block text-center">
        <h6 class="price-list__title">{{ $t('pages.checkins_detail.label_price_list') }}</h6>
        <h4 class="price-list__subtitle" v-if="eventName">{{ eventName }}</h4>
        <div class="price-list__descr" @click="$bvModal.hide('modalPriceList')">
          {{ $t('pages.checkins_detail.price_list_package') }}
        </div>
      </div>
      <div v-if="priceList">
        <template v-if="isSinglePrice">
          <div class="price-list__list">
            <div class="price-list__item">
              <div class="name">{{ $t('pages.checkins_detail.label_price_each_photos') }}</div>
              <div class="value">
                <span v-if="priceList[0].price_original && priceList[0].price_original !== priceList[0].price" class="text-secondary mr-1"><s>{{ priceList[0].price_original|formatCurrency(currency) }}</s></span>
                {{ priceList[0].price|formatCurrency(currency) }} <span class="text-secondary ml-1">({{ currency }})
              </span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isRangePriceList">
          <div class="price-list__list">
            <div class="price-list__item" v-for="price in priceList" :key="price.key">
              <div class="name">
                <span v-if="price.last">+ {{ price.from_qty }}</span>
                <span v-else>{{ price.from_qty }} - {{ price.to_qty }}</span>
                photos
              </div>
              <div class="value">
                <span v-if="price.price_original && price.price_original !== price.price" class="text-secondary mr-1"><s>{{ price.price_original|formatCurrency(currency) }}</s></span>
                {{ price.price|formatCurrency(currency) }} <span class="text-secondary ml-1">({{ currency }})</span>
                {{ $t('pages.checkins_detail.label_price_each') }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="price-list__list">
            <div class="price-list__item" v-for="price in priceList" :key="price.key">
              <div class="name">
                <span v-if="price.last">{{ $t('pages.checkins_detail.label_price_all_photos') }}</span>
                <span v-else>{{ price.qty }} {{ $t('pages.checkins_detail.label_price_photos') }}</span>
              </div>
              <div class="value">
                <span v-if="price.price_original && price.price_original !== price.price" class="text-secondary mr-1"><s>{{ price.price_original|formatCurrency(currency) }}</s></span>
                 {{ price.price|formatCurrency(currency) }} <span class="text-secondary ml-1">({{ currency }})</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="price-list__note">
        {{ note }}
      </div>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="order-sm-0 mr-sm-2 text-center">
            <b-button variant="light" @click="!isPreview ? cancel() : undefined">
              {{ $t('pages.checkins_detail.close_btn_price_list') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: "ModalPriceList",
  props: {
    eventName: {
      type: String,
      required: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isDemo: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      required: false
    },
    currency: {
      type: String,
      required: true
    },
    priceList: {
      type: Array,
      required: true
    },
    priceListImg: {
      type: String,
      required: false
    },
  },
  computed: {
    modalIdentifier() {
      return this.modalId || 'modalPriceList'
    },
    isSinglePrice() {
      //if (!this.data || !this.data.items) return false
      if (this.priceList.length !== 1) return false
      const price = this.priceList[0]
      return price.to_qty && price.to_qty >= 999
    },
    isRangePriceList() {
      if (!this.priceList.length) return false
      return this.priceList.some((item) => item.from_qty && item.to_qty)
    },
    /*priceList() {
      if (!this.data || !this.data.items) return false
      let prices = this.data.items.filter(item => item.unit_price || item.price)
      if (this.isRangePriceList) {
        prices = prices.map(item => ({
          key: `${item.from_qty}-${item.to_qty}`,
          from_qty: item.from_qty,
          to_qty: item.to_qty,
          price: item.unit_price
        }))
      } else {
        prices.map(item => ({
          key: item.qty,
          qty: item.qty,
          price: item.price || Math.round(item.unit_price * item.qty * 10) / 10
        }))
      }
      // Update last item to set it as complete package
      if (prices.length > 0)
        prices[prices.length - 1].last = true
      return prices
    },*/

    note() {
      return this.$t('pages.checkins_detail.note_price_list',
          {currencyName: this.currency, currencySymbol: this.currencySymbol})
    },
    currencySymbol() {
      return this.getCurrencySymbol(this.currency)
    }
  }
}
</script>


<style scoped>

</style>
